import Button from "../common/Button";
import NextBtn from "../common/NextBtn";
import PreviousBtn from "../common/PreviousBtn";
import PreViewMapType from "./PreViewMapType";
import styles from "./MapSettingComplete.module.css";
import commonStyles from "./CreateMapSetting.module.css";
import ContentTitle from "../common/ContentTitle";
import ProgressBar from "../common/ProgressBar";
import { GeocodingStats } from "../../utils/geocodingUtils";

interface MapSettingCompleteProps {
    mapType: string;
    processIdx: number;
    progressProcess: (n: number) => void;
    completeMapSetting: () => void;
    runGeocoding: () => void;
    mapComplete: boolean;
    geoCodingProgress: number;
    geocodingStats: GeocodingStats;
    retry: () => void;
}

/**
 * @author cjs
 * @date 2024-09-12 11:21:47
 * @remark 지도만들기 완료 화면 컴포넌트
 * @pram props
 * @props MapSettingCompleteProps
        mapType(required) : 지도 설정 데이터
        processIdx(required) : 지도만들기 화면 순서
        progressProcess(required) : 지도만들기 화면 순서 변경 함수
        completeMapSetting(required) : 지도만들기 완료 함수
         mapComplete (required) : 지도만들기 완료 여부
    @returns MapSettingComplete
 */

function MapSettingComplete(props: MapSettingCompleteProps) {
    return (
        <>
            <div className={commonStyles.wrapPreView}>
                <PreViewMapType mapType={props.mapType} />
            </div>
            <div className={`${commonStyles.wrap} undraggable`}>
                <div className={commonStyles.container}>
                    {
                        // 완료 버튼을 눌렀을때
                        props.mapComplete ? (
                            <div className={styles.wrapCompleteBtn}>
                                <div className={commonStyles.title}>
                                    <ContentTitle title="결과" />
                                </div>
                                <div className={styles.wrapResult}>
                                    <div className={`${styles.wrappedGrid}`}>
                                        {/* 첫 번째 행: 매칭율과 처리시간 */}
                                        <div className={styles.topStatsRow}>
                                            <div className={styles.statItem}>
                                                <div className={styles.statLabel}>주소 매칭율</div>
                                                <div className={styles.statValue}>
                                                    <div className={styles.progressBar}>
                                                        <div className={styles.progressFill}>
                                                            <div
                                                                className={styles.exactBar}
                                                                style={{ width: `${((props.geocodingStats.exactCnt ) / props.geocodingStats.totalCnt) * 100}%` }}
                                                            />
                                                            <span
                                                                className={styles.exactCountText}
                                                                style={{ left: `${((props.geocodingStats.exactCnt ) / props.geocodingStats.totalCnt) * 100}%` }}
                                                            >
                                                                {props.geocodingStats.exactCnt}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className={styles.percentage}>{props.geocodingStats.matchingRate}%</div>
                                                </div>
                                                <div className={styles.statDescription}>
                                                    <span>지오코딩 과정 중에서 올바르게 입력되지 않은 주소지는 <span className={styles.similarText}>유사한 주소지로 보정</span>됩니다.</span><br/>
                                                    <span><b>'주소 매칭율'</b>은 입력한 데이터에 포함된 주소값 중 <span className={styles.exactText}>좌표로 올바르게 변환된 데이터</span> 의 비율입니다.</span>
                                                </div>
                                            </div>
                                            {/* <div className={styles.statItem}>
                                                <div className={styles.statLabel}>처리시간</div>
                                                <div className={styles.statValue2}>
                                                    <span className={styles.processingTime}>{props.geocodingStats.geocodingProcessingTime}</span>초
                                                </div>
                                            </div> */}
                                        </div>

                                        {/* 두 번째 행: 총합, 완료, 실패 */}
                                        <div className={styles.bottomStatsRow}>
                                            <div className={styles.countItem}>
                                                <div className={styles.countTotalLabel}>총 {props.geocodingStats.totalCnt}건</div>
                                            </div>
                                            <div className={styles.countItem}>
                                                <div className={styles.countLabel}>성공</div>
                                                <div className={styles.countValue}>
                                                    <span className={styles.resultExact}>{props.geocodingStats.exactCnt + props.geocodingStats.similarCnt}</span> 건
                                                </div>
                                            </div>
                                            <div className={styles.countItem}>
                                                <div className={styles.countLabel}>실패</div>
                                                <div className={styles.countValue}>
                                                    <span className={styles.resultFail}>{props.geocodingStats.failCnt}</span> 건
                                                </div>
                                            </div>
                                            <div className={styles.countItem}>
                                                <div className={styles.countLabel}>정확한 주소</div>
                                                <div className={styles.countValue}>
                                                    <span className={styles.resultExact}>{props.geocodingStats.exactCnt}</span> 건
                                                </div>
                                            </div>
                                            <div className={styles.countItem}>
                                                <div className={styles.countLabel}>보정된 주소</div>
                                                <div className={styles.countValue}>
                                                    <span className={styles.resultSimilar}>{props.geocodingStats.similarCnt}</span> 건
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {props.geocodingStats.failCnt > 0 ? (
									<div className={`${styles.textInfo} ${styles.textInfoWide}`}> 
										<span className={styles.resultFail} style={{fontSize: "1.0rem"}}>{props.geocodingStats.failCnt}건의 오류 주소가 있습니다. 주소를 확인하세요.</span>
										{(props.geocodingStats.failedAddresses?.length ?? 0) > 0 && (
											<div className={styles.failedAddressWrap}>
												<ul className={styles.failedAddressList}>
													{props.geocodingStats.failedAddresses?.map((addr, i) => (
														<li key={i} className={styles.failedAddressItem}>
															{addr}
														</li>
													))}
												</ul>
											</div>
										)}
									</div>
                                    // <Button label={"재시도"} background={"#47a930"} size={"large"} onClick={props.retry} />
                                ) : (
                                    <></>
                                )}
                            </div>
                        ) : props.geoCodingProgress == 0 ? (
                            <div className={styles.wrapCompleteBtn}>
                                <div className={styles.textInfo}>
                                    모든 설정이 완료되었습니다.
                                    <br />
                                    [완료] 버튼을 클릭하여 지도 제작을 완료하세요.
                                </div>
                                <button className={styles.completeBtn} onClick={props.runGeocoding}>
                                    완료
                                </button>
                            </div>
                        ) : (
                            <div className={styles.wrapProgressBar}>
                                <ProgressBar
                                    state={props.geoCodingProgress}
                                    label={["지도를 만들고 있습니다."]}
                                    animatedMessages={[
                                        "주소값을 좌표 데이터로 변경하고 있습니다.",
                                        "좌표변환이 불가능한 주소지는 유사한 주소지의 좌표로 변환됩니다.",
                                        "잠시만 기다려주세요..."
                                    ]}
                                />
                            </div>
                        )
                    }

                    <div className={commonStyles.footer}>
                        <div className={commonStyles.wrapProgressBtn}>
                            <div className={`${props.processIdx === 0 ? commonStyles.hideBtn : commonStyles.activeBtn}`}>
                                <PreviousBtn progressProcess={props.progressProcess} />
                            </div>
                            <div className={`${props.mapComplete ? commonStyles.activeBtn : commonStyles.hideBtn}`}>
                                <NextBtn progressProcess={props.progressProcess} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default MapSettingComplete;
